var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',[_vm._v("Projects")]),_c('ProjectList',{attrs:{"displaySelectedProjects":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }